import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import PagePlaceholder from "./components/PagePlaceholder";

export const Page = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [page, setPage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const params = useParams();

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/pages/detail/${params.slug}/`
      )
      .then((res) => {
        console.log(res.data);
        setPage(res.data);
        setIsLoading(false);
      })
      .catch(() => {
        setError("Something went wrong1!");
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params]);

  return (
    <div className="service-page pt-5 pb-5">
      <div className="container">
        <div className="row">
          {isLoading === true ? (
            <PagePlaceholder />
          ) : error === null ? (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-auto">
              <h4
                className=""
                style={{
                  textAlign: "left !important",
                  fontSize: "24px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                {lang === "en"
                  ? page.title_en
                  : lang === "ru"
                  ? page.title_ru
                  : page.title_tm}
              </h4>
              <div
                className="page-content"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "en"
                      ? page.content_en
                      : lang === "ru"
                      ? page.content_ru
                      : page.content_tm,
                }}
              ></div>
            </div>
          ) : (
            `Error: ${error}`
          )}
        </div>
      </div>
    </div>
  );
};
